import * as React from "react";
import { cn } from "../../lib/utils";

// Segments are colored by position, low to high load: green, yellow, orange, red.
const loadColors = ["bg-green-400", "bg-yellow-400", "bg-orange-400", "bg-red-400"] as const;

function LevelMeter({
  level,
  scale = "load",
  className,
  ...props
}: Omit<React.ComponentProps<"div">, "role"> & {
  level: number;
  // "quality" reverses the colors: the first segment is the worst level.
  scale?: "load" | "quality";
}) {
  const colors = scale === "quality" ? [...loadColors].reverse() : loadColors;
  return (
    <div
      data-slot="level-meter"
      role="meter"
      aria-valuenow={level}
      className={cn("grid grid-cols-4 gap-1", className)}
      {...props}
    >
      {colors.map((color, index) => (
        <span
          key={color}
          className={cn("h-1.5 rounded-full", color, index < level ? "opacity-100" : "opacity-20")}
        />
      ))}
    </div>
  );
}

export { LevelMeter };
